import dynamic from 'next/dynamic';
import { wfbAdsSectionLoading as loading } from './WfbAdsSectionLoader';

const DynamicWfbAdsSection = dynamic(() => import(
  './WfbAdsSection'
), {
  ssr: false,
  loading,
});

export default DynamicWfbAdsSection;
